import { createContext, useContext } from "react";
import { AppThemeContext } from "../theme/themeContext";
import { frozenThemeTokens, type ThemeToken } from "../theme/themeTokens.generated";

/**
 * Design-Tokens des Kits (Plan 2026-10-13-antd-ausbau, Stufe 8; Ersatz für Antd `theme.useToken()`): dieselben
 * Schlüssel und Werte, die Antd je Theme berechnet hat (eingefroren in `theme/themeTokens.generated.ts`). Ein Bereich
 * mit eigenem Designvertrag (öffentliche Widgets) setzt seine Tokens über `ThemeTokenContext`.
 */
export const ThemeTokenContext = createContext<ThemeToken | null>(null);

function useToken(): { token: ThemeToken } {
  const override = useContext(ThemeTokenContext);
  const app = useContext(AppThemeContext);
  return { token: override ?? app?.token ?? frozenThemeTokens["violet-light"] };
}

export const theme = { useToken };
export type { ThemeToken };
